export default [
  {
    path: '/report',
    name: 'report',
    component: () => import('@/views/pages/report/Report.vue'),
    meta: {},
    breadcrumb: [
      {
          text: 'Report',
          active: true,
      },
    ]
  },
];
